import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TranslocoModule } from '@jsverse/transloco';
import { IconDirective, TooltipDirective, ButtonDirective } from 'shared/ui-common';

import { ExpandService } from '../../../../../../shared/util-common/src/lib/expand.service';

@Component({
  selector: 'expand-collapse-toggle',
  standalone: true,
  imports: [MatIconModule, TranslocoModule, TooltipDirective, IconDirective, ButtonDirective],
  templateUrl: './expand-collapse-toggle.component.html',
  styleUrls: ['./expand-collapse-toggle.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExpandCollapseToggleComponent {
  private expandService = inject(ExpandService);

  protected isAnyExpanded = this.expandService.isAnyExpanded;

  protected toggleExpandCollapse() {
    if (this.isAnyExpanded()) {
      this.expandService.collapseAll();
      return;
    }

    this.expandService.expandAll();
  }
}
